// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/element";
import "./../../services/finito-service";
import * as $ from "jquery";
import BaseViewModel from "./../../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
import finitoService from "./../../services/finito-service";
class InfoTemplate extends BaseViewModel {
    TemplateName: KnockoutObservable<string> = ko.observable("");
    AreaID: KnockoutObservable<string> = ko.observable("");
    AreaName: KnockoutObservable<string> = ko.observable("");
    States: KnockoutObservableArray<string> = ko.observableArray([]);
    InfoStateId: KnockoutObservable<string> = ko.observable("");
    AreaEquipmentId: KnockoutObservable<string> = ko.observable("");
    AreaEquipmentBinding: KnockoutObservable<string> = ko.observable("");
    Device3Id: KnockoutObservable<string> = ko.observable("");
    Device3NameBinding: KnockoutObservable<string> = ko.observable("");
    Device4Id: KnockoutObservable<string> = ko.observable("");
    Device4NameBinding: KnockoutObservable<string> = ko.observable("");
    InfoLevelId: KnockoutObservable<string> = ko.observable("");
    Priorities: KnockoutObservableArray<string> = ko.observableArray([]);
    CategoryStructureId: KnockoutObservable<string> = ko.observable("");
    Categories: KnockoutObservableArray<string> = ko.observableArray([]);
    TextModuleField: KnockoutObservable<string> = ko.observable("");
    InfoText: KnockoutObservable<string> = ko.observable("");
    IgnoreDeviceChanges: KnockoutObservable<boolean> = ko.observable(false);
    SelectedTextModule: KnockoutObservable<any> = ko.observable("");
    InfoAttachment: KnockoutObservableArray<string> = ko.observableArray([]).extend({ dirty: this.TabPage.DirtyFlag });
    Revision: KnockoutObservable<number> = ko.observable(0);
    InfoId: KnockoutObservable<string> = ko.observable("");
    ShiftbookId: KnockoutObservable<string> = ko.observable("");
    ShiftbookName: KnockoutObservable<string> = ko.observable("");
    isTemplateForAllUsers: KnockoutObservable<boolean> = ko.observable(false);
    PermissionSaveForAllUsers: KnockoutObservable<boolean> = ko.observable(false);
    // ToolbarButtons = tabPage.ToolbarButtons;
    constructor(tabPage: TabPage) {
        super(tabPage);
        this["showTextModuleDialog"] = function () { };
    }
    showAttachmentDialog() {
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.TemplateName())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitDefaults() {
        return Bao.post("MasterData/InfoTemplate/InitDefaults")
            .done((result) => {
            ko.map.fromJS(result, this);
        });
    }
    InitShiftbook() {
        var def = $.Deferred();
        if (!this.ShiftbookId() || this.ShiftbookName()) {
            return def.resolve().promise();
        }
        return Bao.post("MasterData/InfoTemplate/GetShiftbookName", JSON.stringify({
            shiftbookId: this.ShiftbookId()
        }))
            .done((result) => {
            ko.map.fromJS(result, this);
        });
    }
    InitPriorities() {
        return Bao.post("MasterData/InfoTemplate/InitPriorities")
            .done((result) => {
            ko.map.fromJS(result, this);
        });
    }
    InitCategories() {
        return Bao.post("MasterData/InfoTemplate/InitCategories")
            .done((result) => {
            ko.map.fromJS(result, this);
        });
    }
    InitPermission() {
        return Bao.post("MasterData/InfoTemplate/HasPermissionSaveGlobal")
            .done((result) => {
            if (result == true) {
                this.PermissionSaveForAllUsers(result);
            }
        });
    }
    InitWithModel(model) {
        return Bao.post("MasterData/InfoTemplate/GetInfoTemplateByInfo", JSON.stringify({
            model: model
        })).then((result) => {
            ko.map.fromJS(result, this);
        });
    }
    InitUrl() {
        return "MasterData/InfoTemplate/Init";
    }
    loaded() {
        super.loaded();
        this.AreaID.subscribe(() => {
            this.SetChildrenByArea();
        });
        this.Device4Id.subscribe(() => {
            this.SetParentsByDevice4();
        });
        this.Device3Id.subscribe(() => {
            this.SetParentsByDevice3();
        });
        this.AreaEquipmentId.subscribe(() => {
            this.SetParentsByAreaEquipment();
        });
        // Textbaustein einfügen
        this.SelectedTextModule.subscribe((selectedTextModule) => {
            finitoService.InsertAtCursorPosition(this.TextModuleField(), selectedTextModule.Text);
        });
    }
    init() {
        return $.when(super.init(), this.InitDefaults(), this.InitPriorities(), this.InitCategories(), this.InitPermission()).then(() => {
            if (this.TabPage["Route"].InitData != null) {
                return this.InitWithModel(this.TabPage["Route"].InitData);
            }
        })
            .then(() => this.InitShiftbook());
    }
    SetChildrenByArea() {
        var def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaID() != null) {
                this.TabPage.IsLoading(true);
                Bao.post("Device/AreaChildren", JSON.stringify({ areaId: this.AreaID(), areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipment == false) {
                            this.AreaEquipmentId(null);
                            this.AreaEquipmentBinding(null);
                        }
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                this.AreaEquipmentBinding(null);
                this.AreaEquipmentId(null);
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        return def.promise();
    }
    SetParentsByDevice4() {
        var def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            if (this.Device4Id() != null) {
                this.TabPage.IsLoading(true);
                this.IgnoreDeviceChanges(true);
                Bao.post("Device/Device4Parents", JSON.stringify({ device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device3Id != null && this.Device3Id() == null && Bao.Utils.String.IsNullOrWhitespace(this.Device3NameBinding())) {
                            this.Device3Id(result.Device3Id);
                            this.Device3NameBinding(result.Device3Name);
                        }
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaID() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaID(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //device 4 deleted
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    SetParentsByDevice3() {
        var def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.Device3Id() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/Device3Parents", JSON.stringify({ device3Id: this.Device3Id() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaID() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaID(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/Device3Children", JSON.stringify({ device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //Device3 deleted
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    SetParentsByAreaEquipment() {
        var def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaEquipmentId() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/AreaEqupimentParents", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId() }), (result) => {
                    if (result != null) {
                        if (result.AreaId != null && this.AreaID() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaID(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/AreaEquipmentChildren", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //AreaEquipment deleted
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    getInfoAttachments() {
        return Bao.post("Information/GetAttachments", JSON.stringify({ sessionTabId: this.SessionTabId() }));
    }
    ;
    // Dateianhang hinzufügen
    attachmentAdded() {
        //this.TabPage.IsLoading(true);
        //this.TabPage.DirtyFlag(true);
        this.getInfoAttachments();
        //.done(function (data) {
        //    ko.map.fromJS(data, this.InfoAttachment);
        //this.TabPage.IsLoading(false);
        //});
    }
    ;
    //
    // Dateianhang entfernen
    removeAttachment(attachment) {
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        // setzte delete flag property
        attachment.DeleteInRevision(this.Revision());
        // set session info
        Bao.post("Information/RemoveAttachment", JSON.stringify({
            sessionTabId: this.SessionTabId(),
            attachmentId: attachment.InfoAttachmentId(),
            deleteInRevision: this.Revision()
        })).done(function () {
            this.TabPage.IsLoading(false);
        });
    }
    ;
}
export default InfoTemplate;